import { render } from "./AllOrdersAdmin.vue?vue&type=template&id=733dd820"
import script from "./AllOrdersAdmin.vue?vue&type=script&lang=js"
export * from "./AllOrdersAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__